mutation CloseCheckIn($eventId: ID!) {
  closeCheckIn(input: { eventId: $eventId }) {
    markedNoShowCount
    checkInClosedAt
  }
}
